// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2cFKR","gfeWrapper":"CalendarEvent_gfeWrapper__1ZTVW"};